module.exports = __webpack_public_path__ + "img/person5.516c7cf1.jpg";